import React from 'react';

function LeagueCodeSuccessModal({ isOpen, onClose, leagueCode, leagueName }) {
    if (!isOpen) return null;

    const handleCopyCode = () => {
        navigator.clipboard.writeText(leagueCode).then(() => {
            // Could add a brief "Copied!" feedback here
        }).catch(() => {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = leagueCode;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        });
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000,
            padding: '20px'
        }}>
            <div style={{
                backgroundColor: '#2d3748',
                borderRadius: '16px',
                padding: '30px',
                maxWidth: '500px',
                width: '100%',
                color: '#f7fafc',
                position: 'relative',
                textAlign: 'center'
            }}>
                {/* Success Icon */}
                <div style={{
                    fontSize: '64px',
                    marginBottom: '20px'
                }}>
                    🎉
                </div>

                {/* Header */}
                <h2 style={{
                    margin: '0 0 15px 0',
                    fontSize: '24px',
                    color: '#48bb78'
                }}>
                    Private League Created!
                </h2>

                <p style={{
                    margin: '0 0 25px 0',
                    color: '#a0aec0',
                    fontSize: '16px'
                }}>
                    Your private league has been created successfully.
                </p>

                {/* League Name and Code Display */}
                <div style={{
                    backgroundColor: '#1a202c',
                    borderRadius: '12px',
                    padding: '20px',
                    marginBottom: '25px',
                    border: '2px solid #4a5568'
                }}>
                    {/* League Name Section */}
                    <div style={{
                        marginBottom: '20px'
                    }}>
                        <div style={{
                            fontSize: '14px',
                            color: '#a0aec0',
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            League Name
                        </div>
                        <div style={{
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: '#48bb78',
                            marginBottom: '5px'
                        }}>
                            {leagueName}
                        </div>
                    </div>

                    {/* League Code Section */}
                    <div>
                        <div style={{
                            fontSize: '14px',
                            color: '#a0aec0',
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            letterSpacing: '1px'
                        }}>
                            Private League Code
                        </div>
                        <div style={{
                            fontSize: '20px',
                            fontWeight: 'bold',
                            color: '#63b3ed',
                            fontFamily: 'monospace',
                            letterSpacing: '1px',
                            marginBottom: '15px'
                        }}>
                            {leagueCode}
                        </div>
                        <button
                            onClick={() => navigator.clipboard.writeText(leagueCode).catch(() => {})}
                            style={{
                                backgroundColor: '#4299e1',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                padding: '8px 16px',
                                fontSize: '14px',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s ease'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#3182ce'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#4299e1'}
                        >
                            📋 Copy League Code
                        </button>
                    </div>
                </div>

                {/* Instructions */}
                <div style={{
                    backgroundColor: 'rgba(66, 153, 225, 0.1)',
                    borderRadius: '8px',
                    padding: '15px',
                    marginBottom: '25px',
                    border: '1px solid rgba(66, 153, 225, 0.3)'
                }}>
                    <p style={{
                        margin: 0,
                        fontSize: '14px',
                        color: '#e2e8f0',
                        lineHeight: '1.5'
                    }}>
                        <strong>Share this code with friends</strong> to invite them to your private league. 
                        They can join by clicking "Join Private League" and entering this code.
                    </p>
                </div>

                {/* Close Button */}
                <button
                    onClick={onClose}
                    style={{
                        backgroundColor: '#48bb78',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '12px 30px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        cursor: 'pointer',
                        transition: 'background-color 0.2s ease'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#38a169'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#48bb78'}
                >
                    Continue to My Teams
                </button>
            </div>
        </div>
    );
}

export default LeagueCodeSuccessModal;